import { FormikProps } from "formik";

import { PendingDocumentMove } from "../../../../../api/ClientFileApi";
import { InventoryUploadArea } from "../../../../components/inventory-upload-area/InventoryUploadArea";
import { AssetsFormValues } from "../../AssetsView.types";
import { ASSET_UPLOAD_AREAS, AssetsDocumentArea } from "../../AssetsView.utils";

interface Props {
  clientId: string;
  formik: FormikProps<AssetsFormValues>;
  area: AssetsDocumentArea;
  label: string;
  onAddMove: (move: PendingDocumentMove) => void;
  onCancelMove: (documentId: string) => void;
}

export function AssetUploadArea({ area, ...props }: Props) {
  return <InventoryUploadArea {...props} config={ASSET_UPLOAD_AREAS[area]} />;
}
